import Vue from 'vue'
import Router from 'vue-router'
//import auth from '@/store/modules/auth/auth'
//
const Hello = resolve => {
  require.ensure(['@/components/helloParent'], () => {
    resolve(require('@/components/helloParent'));
  });
};
// mapView
const map = resolve => {
  require.ensure(['@/components/mapView'], () => {
    resolve(require('@/components/mapView'));
  });
};
//auth
const Login = resolve => {
  require.ensure(['@/components/auth/login'], () => {
    resolve(require('@/components/auth/login'));
  });
};

//upload image
const uploadImage_1 = resolve => {
  require.ensure(['@/components/uploadImage/uploadImage_1'], () => {
    resolve(require('@/components/uploadImage/uploadImage_1'));
  });
};
const uploadImage_2 = resolve => {
  require.ensure(['@/components/uploadImage/uploadImage_2'], () => {
    resolve(require('@/components/uploadImage/uploadImage_2'));
  });
};
const uploadImage_3 = resolve => {
  require.ensure(['@/components/uploadImage/uploadImage_3'], () => {
    resolve(require('@/components/uploadImage/uploadImage_3'));
  });
};
const uploadImage_4 = resolve => {
  require.ensure(['@/components/uploadImage/uploadImage_4'], () => {
    resolve(require('@/components/uploadImage/uploadImage_4'));
  });
};
const uploadImage_5 = resolve => {
  require.ensure(['@/components/uploadImage/uploadImage_5'], () => {
    resolve(require('@/components/uploadImage/uploadImage_5'));
  });
};

// image details
const imageDetails = resolve => {
  require.ensure(['@/components/imageDetails/imageDetails'], () => {
    resolve(require('@/components/imageDetails/imageDetails'));
  });
};

const filter = resolve => {
  require.ensure(['@/components/filter'], () => {
    resolve(require('@/components/filter'));
  });
};

// upload screens

//screen 0
const uploadSreen_0 = resolve => {
  require.ensure(['@/components/uploadScreens/uploadScreen-0'], () => {
    resolve(require('@/components/uploadScreens/uploadScreen-0'));
  });
};

//screen 1
const uploadSreen1 = resolve => {
  require.ensure(['@/components/uploadScreens/uploadScreen-1'], () => {
    resolve(require('@/components/uploadScreens/uploadScreen-1'));
  });
};

//screen 2
const uploadSreen2 = resolve => {
  require.ensure(['@/components/uploadScreens/uploadScreen-2'], () => {
    resolve(require('@/components/uploadScreens/uploadScreen-2'));
  });
};

// profile dummy page
const profile = resolve => {
  require.ensure(['@/components/profile'], () => {
    resolve(require('@/components/profile'));
  });
};

// page not found
const pageNotFound = resolve => {
  require.ensure(['@/components/page-not-found'], () => {
    resolve(require('@/components/page-not-found'));
  });
};

// search locations
const search_locations = resolve => {
  require.ensure(['@/components/search_locations'], () => {
    resolve(require('@/components/search_locations'));
  });
};

import { getLoginStatus } from '@/helper/auth'
import GoogleAuth from '@/components/auth/browser-extension/google.vue'
import FacebookAuth from '@/components/auth/browser-extension/facebook.vue'
import CompleteSignin from '@/components/auth/completeSignin.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Hello', component: Hello }, // no auth - 1
    {
      path: '/map', name: 'Map', component: map
    }, // no auth - 1
    { path: '/Login', name: 'Login', component: Login }, // no auth - 2
    { path: '/complete-signin', name: 'CompleteSignin', component: CompleteSignin }, // no auth - 2
    { path: '/uploadImage_1', name: 'Upload Image 1', component: uploadImage_1 },
    { path: '/uploadImage_2', name: 'Upload Image 2', component: uploadImage_2 },
    { path: '/uploadImage_3', name: 'Upload Image 3', component: uploadImage_3 },
    { path: '/uploadImage_4', name: 'Upload Image 4', component: uploadImage_4 },
    { path: '/uploadImage_5', name: 'Upload Image 5', component: uploadImage_5 },
    // image details
    { path: '/id/:id', name: 'Image Details', component: imageDetails }, // no auth - 5
    { path: '/imageDetails/:id', name: 'old image details', redirect:{ name: 'Image Details' } }, // no auth - 5
    // Filter
    { path: '/filter', name: 'Filter', component: filter},
    // new upload screens
    // screen-1
    { path: '/upload-1', name: 'Upload Screen 1', component: () => import("../components/uploadScreens/uploadScreen-1.vue") },
    // screen-2
    { path: '/upload-2', name: 'Upload Screen 2', component: () => import("../components/uploadScreens/uploadScreen-2.vue") },
    // profile page
    { path: '/profile', name: 'Profile', component: profile},
    { path: '/upload-0', name: 'Upload Screen 0', component: uploadSreen_0 },
    {
      path: '/auth/extension-firebase/google',
      name: 'ExtensionFirebaseGoogle',
      component: GoogleAuth
    },
    {
      path: '/auth/extension-firebase/facebook',
      name: 'ExtensionFirebaseFacebook',
      component: FacebookAuth
    },
    //
    // { path: '/search_locations', name: 'search_locations', component: search_locations },
    // page not found
    { path: '*', name: 'pageNotFound', component: pageNotFound }
  ]
})

let noAuthReqRoutes = [
  'Hello',
  'Login',
  'CompleteSignin',
  'Image Details',
  'pageNotFound',
  'Profile',
  'Map',
  'Settings',
  'Filter',
  'ExtensionFirebaseGoogle',
  'ExtensionFirebaseFacebook'
]

router.beforeEach((to, from, next) => {


  localStorage.setItem('to', to.name != null ? to.name : 'null')
  localStorage.setItem('from', from.name != null ? from.name : 'null')
  localStorage.setItem('toPath', to.name != null ? JSON.stringify(to.query) : 'null')
  localStorage.setItem('fromPath', from.name != null ? JSON.stringify(from.query) : 'null')
  localStorage.setItem(`imgDet_status`, `unresolved`)
  if (to.name === `Image Details`) {
    // console.log(`// check > going to image detail page...`)

    //
    if (from.name === null) {

      // console.log(`// coming from no where...`)
      localStorage.setItem(`imgDet_status`, `comingFromLink`)
    }
    else {

      // console.log(`// coming from an internal app link...`)
      //
      // hadling expection in this case.
      // console.log(`// check exception > if coming from img det itself by clicking on nearby`)
      //
      if (from.name === `Image Details`) {
        // console.log(`// coming from img det, may be clicked on nearby`)
        localStorage.setItem(`imgDet_status`, `comingFromLink`)
      }
      else {
        // console.log(`// coming from other page within app`)
        localStorage.setItem(`imgDet_status`, `comingFromApp`)
      }
      //
    }
  }
  // check > going to image detail page... end


  // auth not resolved.
  //setTimeout(() => {
  getLoginStatus().then((res) => {
    let isLoggedIn = res.isLoggedIn
    if (!isLoggedIn) {
      if (noAuthReqRoutes.indexOf(to.name) == -1) {
        // next(from)
        next({
          path: `/login`
        }) // restrict route
      }
      else {
        if (to.name !== null) {
          next()
        }
        else {
          next(false)
          router.push('/')
        }
      }
    }
    else {
      if (to.name !== null) {
        next()
      }
      else {
        next(false)
        router.push('/')
      }
    }
  })
  //}, 200)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js